

import templateTermsAndConditionsPage from '@/app-template/lib/pages/TermsAndConditionsPage.vue';

export default {
  name: "TermsAndConditionsPage",
  components: { templateTermsAndConditionsPage },
};
